import { createSlice } from "@reduxjs/toolkit";
export const authSlice = createSlice({
  name: "auth",
  initialState: {
    token: localStorage.getItem("token") || null,
    isAuthenticated: false,
    loading: true,
    error: null,
    user: {} || null,
  },
  reducers: {
    authUserSuccess: (state, action) => {
      state.isAuthenticated = true;
      state.token = action.payload.token;
      state.loading = false;
      state.user = action.payload.user;
    },
    authUserFailed: (state) => {
      localStorage.removeItem("token");
      state.isAuthenticated = false;
      state.token = null;
      state.loading = true;
      state.user = {};
    },
    setUser:(state, action)=>{
      state.user = action.payload
    }
  },
});

export const { authUserFailed, authUserSuccess, setUser } = authSlice.actions;
export default authSlice.reducer;
